import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=74e2fbe6&scoped=true&"
import script from "./Teams.vue?vue&type=script&lang=js&"
export * from "./Teams.vue?vue&type=script&lang=js&"
import style0 from "./Teams.vue?vue&type=style&index=0&id=74e2fbe6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e2fbe6",
  null
  
)

export default component.exports